var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEducationDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.275 12.42v2.858c0 .814.347 1.587 1.08 1.94 1.186.572 3.04 1.174 4.645 1.174 1.605 0 3.459-.602 4.644-1.174.734-.353 1.08-1.126 1.08-1.94v-2.91l-.802.386a11.5 11.5 0 0 1-9.95 0l-.697-.335Zm0-1.664v-.814l3.1 1.254a7 7 0 0 0 5.25 0l3.1-1.254v.763l-1.452.697a10 10 0 0 1-8.652 0l-1.346-.646Z",
  fill: "#3A434A"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.475 15.278c0 1.007-.436 2.1-1.505 2.616-1.244.6-3.213 1.248-4.97 1.248-1.757 0-3.726-.648-4.97-1.248-1.07-.516-1.505-1.61-1.505-2.616v-3.164l1.505.664-.005 2.5c0 .622.258 1.073.657 1.265 1.126.543 2.865 1.1 4.318 1.1 1.453 0 3.192-.557 4.318-1.1.399-.192.657-.643.657-1.265l-.005-2.552 1.505-.777v3.329Z",
  fill: "#3A434A"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.621 3.553 1.2 5.673C-.313 6.4-.313 8.555 1.2 9.28l4.421 2.122a10 10 0 0 0 8.652 0l4.421-2.122c1.514-.726 1.514-2.88 0-3.606l-4.421-2.121a10 10 0 0 0-8.652 0Z",
  fill: "#3A434A"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.27 4.905 1.85 7.026a.5.5 0 0 0 0 .902l4.421 2.121a8.5 8.5 0 0 0 7.354 0l4.421-2.121a.5.5 0 0 0 0-.902l-4.421-2.121a8.5 8.5 0 0 0-7.354 0Zm-5.07.769L5.62 3.553a10 10 0 0 1 8.652 0l4.421 2.12c1.514.727 1.514 2.881 0 3.607l-4.421 2.122a10 10 0 0 1-8.652 0L1.2 9.28c-1.513-.726-1.513-2.88 0-3.606Z",
  fill: "#3A434A"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.08 6.907a.75.75 0 0 1 .75.75v4.686a.75.75 0 0 1-1.5 0V7.657a.75.75 0 0 1 .75-.75Z",
  fill: "#3A434A"
})));
export default SvgEducationDark;